/**
 * 쇼핑 정책 폼 공용 유틸 — 숫자 입력 클램프 + 감사 메타 표시 포맷.
 * BE 도 하한/상한을 클램프하지만 폼에서 선제 가드해 일관된 UX 를 제공한다.
 */

/** 양의 정수 보정. min(기본 1) 미만/비정상 입력은 min 으로, max 초과는 max 로 클램프. */
export const clampInt = (raw: string, min = 1, max = Number.MAX_SAFE_INTEGER): number => {
  const n = Math.floor(Number(raw));
  if (!Number.isFinite(n)) return min;
  if (n < min) return min;
  if (n > max) return max;
  return n;
};

/** ISO 문자열 → `YYYY-MM-DD HH:mm`. null/빈/파싱불가 시 원문 또는 '-'. */
export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '-';
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  const pad = (n: number) => `${n}`.padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
